// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rNpf","rootMobile":"styles_rootMobile__1kGdL"};